import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppLoadService } from '@ebb-v2/ebb-integration';
import { map } from 'rxjs/operators';

interface RecaptchaStatus {
  enabled: boolean;
  siteKey: string;
}

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpClient,
    private appLoadService: AppLoadService
  ) {
    this.baseUrl = this.appLoadService.readEnvironSettings().uriApi;
  }

  /**
   * Gets whether reCAPTCHA is enabled and the current site key
   */
  public isRecaptchaEnabled(): Observable<RecaptchaStatus> {
    const url = `${this.baseUrl}/Recaptcha/IsEnabled`;
    return this.http.get<RecaptchaStatus>(url).pipe(
      map(res => ({
        enabled: res?.enabled ?? false,
        siteKey: res?.siteKey ?? ''
      }))
    );
  }

  /**
   * Verifies the reCAPTCHA token on the backend
   * @param token The token received from Google reCAPTCHA v3
   */
  public verifyRecaptcha(token: string,action:string,email:string): Observable<any> {
    const url = `${this.baseUrl}/Recaptcha/verify`;
    const headers = new HttpHeaders({
      'recaptchaToken': token,
      'recaptchaAction': action,    
      'email': email
    });

    return this.http.get<{ res}>(url, { headers }).pipe(
      map(res => res)
    );
  }
}
